<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>股东设置</el-breadcrumb-item>
        <el-breadcrumb-item>分红记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="border-bottom: 1px solid #EEEEEE;padding-bottom: 10px;">
          <el-col :span="24" align="left">&nbsp;
            <span>分红金额基数：</span>
            <el-input
              style="width: 100px"
              placeholder="请输入分红金额基数"
              v-model="money_total"
              clearable>
            </el-input>
            <span>分红百分比率（%）：</span>
            <el-input
              style="width: 100px"
              placeholder="请输入分红百分比率"
              v-model="ratioValue"
              clearable>
            </el-input>
            <el-button type="primary" @click="ratio()">保存</el-button>
          </el-col>
<!-- <el-col :span="24" align="left">&nbsp;-->
<!--          -->
<!--            <el-button type="primary" @click="ratio()">保存</el-button>-->
<!--          </el-col>-->

        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
<!--          <el-table-column-->
<!--            label="ID"-->
<!--            prop="record_id">-->
<!--          </el-table-column>-->
          <el-table-column
            label="创建分红人"
            prop="name_create">
          </el-table-column>
          <el-table-column
            label="本次分红金额基数"
            prop="money_total">
          </el-table-column>

         <el-table-column
            label="本次分红比率(%)"
            prop="bonus_ratio">
          </el-table-column>
         <el-table-column
            label="本次红利总额"
            prop="money_bonus_total">
          </el-table-column>
         <el-table-column
            label="本次分红股东人数"
            prop="bonus_user_count">
          </el-table-column>
         <el-table-column
            label="本次人均红利金额"
            prop="bonus_user_average">
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="create_time">
          </el-table-column>
         <el-table-column
            label="取消分红人"
            prop="name_cancel">
          </el-table-column>
        <el-table-column
            label="取消分红回扣红利总额"
            prop="cancel_money">
          </el-table-column>
        <el-table-column
            label="取消分红理由"
            prop="cancel_reason">
          </el-table-column>
        <el-table-column
            label="取消分红时间"
            prop="cancel_time">
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.cancel_time) }}
                      </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="备注"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
          <!--              {{ scope.row.remarks }}-->
          <!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="状态"
            width="120">
            <template slot-scope="scope">
              {{scope.row.state==1?'已成功分红' :scope.row.state==2?'已取消分红':''}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="ProcessingMesge(scope.row.bonus_id)" v-if="scope.row.state=='1'" size="small" type="text">取消分红</el-button>

            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>

    </el-row>
    <el-dialog title="取消分红" :visible.sync="aaVis" width="360px" :modal-append-to-body="false">

      <div style="text-align: left;line-height: 30px;font-size: 16px">取消理由：</div>
      <el-input clearable v-model="cancel_reason"  type="textarea" auto-complete="off" placeholder="请输入"
                required></el-input>


      <div slot="footer" class="dialog-footer">
        <el-button @click="aaVis = false">取 消</el-button>
        <el-button type="primary" @click="Processing()">确 定</el-button>
      </div>
    </el-dialog>
    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  export default {
    name: "Bonus",
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
      // this.getRatio()
    },
    data() {
      return {
        ratioValue:'',
        money_total:'',
        dataa: [],
        datatotal: 0,
        pagesize: 10,
        cancel_reason:'',
        currentPage: 1,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        activeName: '',
        fullscreenLoading: false,
        aaVis: false,
        //表格
        formLabelWidth: '100px',


      }
    },
    computed: {

    },
    watch: {},
    methods: {
      panduanleixing2(type) {
        switch (type) {
          case '1':
            return "";
            break;
          case '2':
            return "success";
            break;
          case '3':
            return "success";
            break;
          case '4':
            return "info";
            break;
          default:
            return null;
        }
      },
      //处理提示
      ProcessingMesge(id,phone) {
        let thi = this
     thi.aaVis=true
        thi.cancel_reason=''
        thi.bonus_id=id
      },
      //处理
      Processing(id,phone) {
        let thi = this
        thi.fullscreenLoading = true
        console.log(id)
        this.$http.post(global.posturl.host + global.posturl.removeBonus, {
          bonus_id: thi.bonus_id,
          cancel_reason:thi.cancel_reason
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
            thi.aaVis=false
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.listBonus, {
          page: thi.currentPage,
          pageSize: thi.pagesize,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.dataa = qdata
            thi.datatotal = qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //比例获取
      getRatio() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.shareholderRateGet,
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.ratioValue = qdata.content
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //比例设置
      ratio() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.addBonus, {
          bonus_ratio: thi.ratioValue,
          money_total: thi.money_total
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          if (qcode == 200) {
            thi.getstart()
            thi.$message({
              message: qmsg,
              type: 'success',
            });
          } else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      handleNodeClick(data) {
        console.log(data);
      },

      //删除提示
      changevaluestate(user_id, state) {
        var heeh = '该'
        var caozuo = '禁用'
        if (user_id.length > 1) {
          heeh = '这些'
        }
        if (state == 0) {
          caozuo = '删除'
        }
        let thi = this
        thi.$confirm('此操作将' + caozuo + heeh + '账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.submitchangestate(user_id, state)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消' + caozuo
          });
        });
      },
      //状态改变(删除)
      submitchangestate(user_id,state ) {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userStateChange, {
          user_id: user_id,
          state: 0,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //格式化时间
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds() + "";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //状态改变（启用）
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userStateChange, {
          user_id: user_id,
          state: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //白名单状态改变
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userwhitelistChange, {
          user_id: user_id,
          whitelist: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/partner/Bonus.vue